import {AddOptimizationImgUrlAction, OptimizationActionType, SetOptimizationImgInProgressAction} from "./types";

export const setOptimizationImgInProgress = (id: string): SetOptimizationImgInProgressAction => ({
    type: OptimizationActionType.SETINPROGRESS,
    payload: id
});

export const addOptimizationImgUrl = (id: string, url: string): AddOptimizationImgUrlAction => ({
    type: OptimizationActionType.ADDIMGURL,
    payload: {id, url}
});